module.exports = __webpack_public_path__ + "static/fonts/barlowcondensed-light-webfont.3083fbb.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-light-webfont.woff
// module id = 352
// module chunks = 0